import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';
import axios from 'axios';
import AbstractModalView from 'common/components/AbstractModalView';
import AnimatedProgress from '../../../../common/components/AnimatedProgress';
import {showGlobalErrorMessage} from 'common/actions/globalErrorMessage/showGlobalErrorMessage';
import apiIcon from '../../assets/api-24px.svg';
import {Govmap} from '../../utils/govmap';
import {errors as E} from 'common/constants/errors';
import styles from './styles.module.scss';

const GovmapImagePopup = ({
                            buttonLabel,
                            address,
                            onFileApproved,
                          }) => {
  const dispatch = useDispatch();
  const [img, setImg] = useState('');

  const getImage = ({x, y}) => {
    const url = `https://ags.govmap.gov.il/staticmap/GetStaticMap?img&lg&b=0&c=${x},${y}&z=10&in=0&width=600&height=600&sbs=1&mk=1&xy=1&bb=1&bmw=44&lay=PARCEL_ALL&bs=PARCEL_ALL%7C${x},${y}&staticmap`;
    setImg(url);
  };

  async function openCoords(openModal, closeModal) {
    const govmap = new Govmap();
    const coords = await govmap.getGeomapCoordinatesByAddress(address);
    if (coords) {
      getImage(coords);
    } else {
      dispatch(showGlobalErrorMessage(E.WRONG_ADDRESS));
      closeModal();
    }
  }

  const handleOpenModal = async (openModal, closeModal, e) => {
    e.stopPropagation();
    e.preventDefault();
    if (Boolean(address)) {
      openModal();
      await openCoords(openModal, closeModal);
    } else {
      dispatch(showGlobalErrorMessage(E.FILL_ADDRESS));
      closeModal();
    }
  };

  const handleUpload = async closeModal => {
    try {
      if (!img) return;

      const response = await axios.get(img, {responseType: 'blob'});
      const file = new Blob([response.data], {type: 'image/png'});
      file.name = `govmap-captured-image.png`;
      onFileApproved(file);
    } finally {
      closeModal();
    }
  };

  const handleCancel = closeModal => {
    setImg('');
    closeModal();
  };

  return (
    <AbstractModalView
      subPath={'api-confirmation'}
      triggerContent={({openModal, closeModal}) => (
        <>
          <div className={styles.buttonViewApiConfirmation}
               onClick={e => handleOpenModal(openModal, closeModal, e)}>
            <img
              src={apiIcon}
              className={styles.apiIcon}
              alt="apiIcon"
            />
            <div>{buttonLabel}</div>
          </div>
        </>
      )}
      modalContent={({closeModal}) => (
        <>
          <div className={styles.modalContentContainer}>
            {img
              ? (
                <div className={styles.modalApiImage}>
                  <img src={img} alt="map" className={styles.image}/>
                </div>
              )
              : (
                <div className={styles.modalApiImageDumb}>
                  <AnimatedProgress/>
                  <div id="map" className={styles.hidden}/>
                </div>
              )
            }
            <div className={styles.modalButtons}>
              <button
                type="button"
                className={styles.buttonCancel}
                onClick={() => handleCancel(closeModal)}
              >
                <span>ביטול</span>
              </button>
              <button
                type="button"
                className={styles.buttonSubmit}
                onClick={() => handleUpload(closeModal)}
              >
                <span>אשר והוסף לשומה</span>
              </button>
            </div>
          </div>
        </>
      )}
    />
  );
};

GovmapImagePopup.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  address: PropTypes.string,
  onFileApproved: PropTypes.func.isRequired,
};

export default GovmapImagePopup;
